// checkAdsReadyButton.js
var CheckAdsReadyButton = pc.createScript('checkAdsReadyButton');

CheckAdsReadyButton.attributes.add('buttonType', {type: 'string'});
CheckAdsReadyButton.attributes.add('startExtraTimeButton', {type: 'entity'});

CheckAdsReadyButton.prototype.initialize = function() {
    this.failExtraTimeButton = this.app.root.findByTag("levelFailedExtraTimeButton")[0];
};

CheckAdsReadyButton.prototype.update = function (dt) {
    if (this.buttonType == "start") {
        this.startExtraTimeButton.enabled = true;
    }
    else {
        this.entity.button.active = true;
        this.failExtraTimeButton.script.scripts[1].enabled = true;
    }
};


